import { ConnectionSvg } from '../illustrations/connection.js';
import { EmptySvg } from '../illustrations/empty.js';
import { FileSearchingSvg } from '../illustrations/file-searching.js';
import { FixingBugsSvg } from '../illustrations/fixing-bugs.js';
import { GoingOfflineSvg } from '../illustrations/going-offline.js';
import { LostSvg } from '../illustrations/lost.js';
import { MaintenanceSvg } from '../illustrations/maintenance.js';
import { NoDataSvg } from '../illustrations/no-data.js';
import { PageNotFoundSvg } from '../illustrations/page-not-found.js';
import { ServerDownSvg } from '../illustrations/server-down.js';
import { VoidSvg } from '../illustrations/void.js';
import { WarningSvg } from '../illustrations/warning.js';
import { cx } from '../utils/cx.js';
import styles from './StateIllustration.module.css';

export type StateIllustrationVariant =
  | 'error'
  | 'not-found'
  | 'empty'
  | 'void'
  | 'warning'
  | 'offline'
  | 'maintenance'
  | 'no-data'
  | 'lost'
  | 'connection'
  | 'search'
  | 'fixing';

const SVG_BY_VARIANT: Record<StateIllustrationVariant, string> = {
  error: ServerDownSvg,
  'not-found': PageNotFoundSvg,
  empty: EmptySvg,
  void: VoidSvg,
  warning: WarningSvg,
  offline: GoingOfflineSvg,
  maintenance: MaintenanceSvg,
  'no-data': NoDataSvg,
  lost: LostSvg,
  connection: ConnectionSvg,
  search: FileSearchingSvg,
  fixing: FixingBugsSvg,
};

export type StateIllustrationProps = {
  variant: StateIllustrationVariant;
  size?: 'sm' | 'md' | 'lg';
  tone?: 'soft' | 'default';
  className?: string;
};

/** unDraw illustrations — WaPharma palette, transparent backdrops. */
export function StateIllustration({ variant, size = 'md', tone = 'default', className }: StateIllustrationProps) {
  const svg = SVG_BY_VARIANT[variant];
  return (
    <div
      className={cx(
        styles.root,
        size === 'sm' && styles.sizeSm,
        size === 'lg' && styles.sizeLg,
        tone === 'soft' && styles.toneSoft,
        className,
      )}
      aria-hidden
      dangerouslySetInnerHTML={{ __html: svg }}
    />
  );
}
